import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FFDC17"
          d="M8.184 3.007c.107.007.211.019.314.036l.42-.936-.05 1.023c.101.03.2.066.297.107l.626-.815-.287.988c.09.053.177.11.26.172l.803-.653-.51.896c.076.072.148.147.215.226l.933-.451-.705.755c.056.087.108.177.155.269l1.015-.227-.864.576c.035.096.065.195.09.296l1.04.011-.972.363c.01.101.017.205.017.31l1.01.248-1.033.13a2.95 2.95 0 0 1-.055.304l.926.473L10.791 7c-.036.097-.076.19-.122.282l.792.674-.982-.344c-.057.086-.12.168-.186.247l.613.836-.879-.56c-.075.07-.155.135-.237.197l.404.956-.723-.745c-.09.05-.182.098-.278.14l.17 1.018-.53-.888c-.1.028-.2.053-.303.072l-.071 1.03-.309-.985a3.064 3.064 0 0 1-.312 0l-.308.984-.072-1.028a2.99 2.99 0 0 1-.304-.072l-.528.887.169-1.015a2.984 2.984 0 0 1-.28-.14l-.72.742.401-.952a2.992 2.992 0 0 1-.24-.198l-.873.557.61-.83a2.976 2.976 0 0 1-.19-.25l-.975.341.786-.67A2.93 2.93 0 0 1 5.19 7l-1.03.108.919-.47a2.93 2.93 0 0 1-.057-.308L4 6.201l1-.247c.001-.106.007-.21.018-.313l-.964-.36 1.033-.012c.025-.102.056-.202.09-.3l-.857-.572 1.007.226c.048-.094.1-.185.157-.272L4.784 3.6l.927.449c.068-.08.14-.156.217-.228l-.506-.892.799.65c.084-.062.171-.119.262-.172l-.285-.985.624.813c.097-.04.196-.076.298-.107l-.049-1.02.42.934a3.02 3.02 0 0 1 .314-.036L7.995 2l.19 1.007Zm-.21.701a2.26 2.26 0 0 0-2.269 2.25 2.259 2.259 0 0 0 2.269 2.249 2.259 2.259 0 0 0 2.267-2.249 2.26 2.26 0 0 0-2.267-2.25ZM7.873 5.97c.328.423.555 1.009.685 1.64a1.705 1.705 0 0 1-1.282-.058c.008-.59.206-1.116.597-1.582Zm.34-.18c.453.522.738.969.719 1.634a1.711 1.711 0 0 1-.1.06c-.134-.663-.387-1.185-.742-1.603l.088-.066.035-.025Zm-.517.007c-.417.475-.646 1.011-.685 1.605a1.72 1.72 0 0 1-.147-.115c.158-.628.42-1.145.794-1.52l.038.03Zm.772-.115c.557.269.87.905.892 1.335a1.72 1.72 0 0 1-.159.187c-.032-.589-.282-1.038-.733-1.522ZM7.45 5.678a2.989 2.989 0 0 0-.824 1.355l-.04-.05c.03-.435.305-1.05.864-1.305Zm2.11-.363a1.708 1.708 0 0 1-.008 1.375c-.119-.423-.387-.853-.984-1.114.27-.132.601-.233.992-.26Zm-3.153.011c.393.044.704.139.937.25-.592.25-.825.656-.943 1.07a1.709 1.709 0 0 1 .006-1.32Zm1.58-1.046c.478 0 .91.196 1.22.512-.488.057-.903.18-1.24.37-.3-.172-.706-.289-1.216-.355a1.71 1.71 0 0 1 1.236-.527Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
